module.exports = __webpack_public_path__ + "img/4.256f4d09.png";